import React from "react";
import { toast } from "react-toastify";
import { Form, Button } from "react-bootstrap";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import ArrowBackOutlinedIcon from "@material-ui/icons/ArrowBackOutlined";
import ArrowForwardOutlinedIcon from "@material-ui/icons/ArrowForwardOutlined";

import axios from "../../../../axios";
import apiError from "../../../../error";
import Spinner from "../../../spinner/spinner";
import PreviewImageModal from "../../../create-template/ransomware-file/preview-image-modal";
import {
	ViewScreenEyeIcon,
	WindowsPlatformIcon,
	ApplePlatformIcon,
} from "../../../create-template/ransomware-file/ransomware-file-icons";
import "../../../create-template/ransomware-file/ransomware-file.css";
import {PiSkullLight } from "react-icons/pi";

const DEFAULT_RANSOMWARE_DESCRIPTION =
	"Document contains embedded macros that are disabled by default. Manual review recommended before enabling macros.";

const hasPlatformFile = (value) =>
	value != null && String(value).trim().length > 0;

export default class RansomwareFile extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			ransonware_file: "",
			ransomwareFileId: 0,
			ransomwareFiles: [],
			showPreviewModal: false,
			previewWindowsImageSrc: "",
			previewMacImageSrc: "",
			pageHtml: "",
			pageLandingUrl: "",
			pageRedirectUrl: "",
			pageBluePage: false,
			pageCapturePasswords: false,
			pageCaptureCredentials: false,
		};
	}

	componentDidMount() {
		this.initializeTabData();
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.isActive && this.props.isActive) {
			this.initializeTabData();
		}
		if (prevProps.pageId !== this.props.pageId) {
			this.loadPageRansomwareFields();
		}
	}

	initializeTabData = () => {
		if (!this.props.isActive) {
			return;
		}
		this.loadRansomwareFiles();
		this.loadPageRansomwareFields();
	};

	loadRansomwareFiles = () => {
		axios
			.get("/api/ransomware/getFile", {})
			.then((res) => {
				this.setState({ ransomwareFiles: res.data.ransomwareFiles || [] });
			})
			.catch((error) => {
				apiError(error);
			});
	};

	loadPageRansomwareFields = () => {
		if (!this.props.pageId) {
			return;
		}
		axios
			.get("/api/pages/" + this.props.pageId, {})
			.then((res) => {
				const page = res.data.page || {};
				const fileName = page.ransonware_file || "";
				const fileId = page.ransomwareFileId || 0;
				this.setState({
					ransonware_file: fileName,
					ransomwareFileId: fileId,
					pageHtml: page.html || "",
					pageLandingUrl: page.landing_url || "",
					pageRedirectUrl: page.redirect_url || "",
					pageBluePage: !!page.bluePage,
					pageCapturePasswords: !!page.capture_passwords,
					pageCaptureCredentials: !!page.capture_credentials,
				});
				if (
					fileName &&
					String(fileName).trim().length > 0 &&
					parseInt(fileId, 10) > 0 &&
					this.props.onRansomwareFileComplete
				) {
					this.props.onRansomwareFileComplete();
				}
			})
			.catch((err) => {
				apiError(err);
			});
	};

	handlePreviewImage = () => {
		const selectedFile = this.getSelectedRansomwareFile();
		const hasWindows = hasPlatformFile(selectedFile?.filename);
		const hasMac = hasPlatformFile(selectedFile?.macFilename);

		this.setState({
			showPreviewModal: true,
			previewWindowsImageSrc: hasWindows
				? selectedFile?.thumbnailUrl || ""
				: "",
			previewMacImageSrc: hasMac
				? selectedFile?.macThumbnailUrl || ""
				: "",
		});
	};

	getPlatformAvailability = (file) => ({
		windows: hasPlatformFile(file?.filename),
		mac: hasPlatformFile(file?.macFilename),
	});

	handleClosePreviewModal = () => {
		this.setState({
			showPreviewModal: false,
			previewWindowsImageSrc: "",
			previewMacImageSrc: "",
		});
	};

	hasRansomwareFileSelected = () => {
		const fileId = parseInt(this.state.ransomwareFileId, 10);
		return !Number.isNaN(fileId) && fileId > 0;
	};

	getSelectedRansomwareFile = () => {
		const fileId = parseInt(this.state.ransomwareFileId, 10);
		if (!fileId) {
			return null;
		}
		return (
			this.state.ransomwareFiles.find(
				(file) => parseInt(file.id, 10) === fileId
			) || null
		);
	};

	handleSave = () => {
		if (!this.props.pageId) {
			toast.error("Please complete the Landing Page step first");
			return;
		}

		if (
			!this.state.ransonware_file ||
			this.state.ransonware_file.length === 0 ||
			this.state.ransonware_file.trim().length === 0
		) {
			toast.error("Please Enter Ransomware File Name");
			return;
		}

		if (
			!this.state.ransomwareFileId ||
			parseInt(this.state.ransomwareFileId, 10) === 0
		) {
			toast.error("Please Select Ransomware File");
			return;
		}

		if (!this.props.campaignTemplateId) {
			toast.error("Missing campaign template context");
			return;
		}

		const data = {
			ransonware_file: this.state.ransonware_file,
			ransomwareFileId: this.state.ransomwareFileId,
			html: this.state.pageHtml,
			landing_url: this.state.pageLandingUrl,
			redirect_url: this.state.pageRedirectUrl,
			bluePage: this.state.pageBluePage,
			capture_passwords: !!this.state.pageCapturePasswords,
			capture_credentials: !!this.state.pageCaptureCredentials,
			campaignTemplateId: this.props.campaignTemplateId,
		};

		this.setState({ loading: true });
		axios
			.patch("/api/pages/" + this.props.pageId, data)
			.then(() => {
				this.setState({ loading: false });
				if (this.props.onRansomwareFileComplete) {
					this.props.onRansomwareFileComplete();
				}
				this.props.handleTabChange("next");
				toast.success("Ransomware file saved successfully");
			})
			.catch((error) => {
				apiError(error);
				this.setState({ loading: false });
			});
	};

	renderRansomwarePreviewCard() {
		const selectedFile = this.getSelectedRansomwareFile();
		const { windows: hasWindows, mac: hasMac } =
			this.getPlatformAvailability(selectedFile);
		const title =
			this.state.ransonware_file ||
			(selectedFile && selectedFile.name) ||
			"Encryptor_Payload_V4";
		const description =
			(selectedFile && selectedFile.description) ||
			DEFAULT_RANSOMWARE_DESCRIPTION;

		return (
			<div className="ransomware-file-preview-card">
				<div className="ransomware-file-preview-card__left">
					<div className="ransomware-file-preview-card__icon">
						<PiSkullLight />
					</div>
					<div className="ransomware-file-preview-card__content">
						<h6 className="ransomware-file-preview-card__title">{title}</h6>
						<p className="ransomware-file-preview-card__description">
							{description}
						</p>
						<button
							type="button"
							className="ransomware-file-preview-card__view-btn"
							onClick={this.handlePreviewImage}
						>
							<ViewScreenEyeIcon />
							View Screen
						</button>
					</div>
				</div>
				{(hasWindows || hasMac) && (
					<div className="ransomware-file-preview-card__compatible">
						<p className="ransomware-file-preview-card__compatible-label">
							Compatible With
						</p>
						<div className="ransomware-file-preview-card__platforms">
							{hasWindows && (
								<span className="ransomware-file-preview-card__platform ransomware-file-preview-card__platform--windows">
									<WindowsPlatformIcon />
								</span>
							)}
							{hasMac && (
								<span className="ransomware-file-preview-card__platform">
									<ApplePlatformIcon />
								</span>
							)}
						</div>
					</div>
				)}
			</div>
		);
	}

	render() {
		return (
			<>
				<div className="email-template-wrap">
					<div className="rightSectionHeader">
						<div className="row justify-content-between align-items-center">
							<div className="col-md-6 tab-right-header">
								<h6>Ransomware File</h6>
								<p>Configure ransomware file for the campaign</p>
							</div>
						</div>
					</div>
					<div className="setMarginCss">
						<Form>
							<Form.Group>
								<Form.Label>
									Ransomware File Name
									<OverlayTrigger
										placement="top"
										overlay={
											<Tooltip id="ransomware-filename">
												This would be the name of the executable ransomware file
											</Tooltip>
										}
									>
										<HelpOutlineIcon className="tooltip-icon" />
									</OverlayTrigger>
								</Form.Label>
								<Form.Control
									type="text"
									value={this.state.ransonware_file}
									onChange={(e) =>
										this.setState({ ransonware_file: e.target.value })
									}
									placeholder="Please enter ransomware file name"
								/>
							</Form.Group>

							<Form.Group>
								<Form.Label>
									Select Ransomware File
									<OverlayTrigger
										placement="top"
										overlay={
											<Tooltip id="ransomware-select">
												Choose the ransomware file you will be using for the campaign
											</Tooltip>
										}
									>
										<HelpOutlineIcon className="tooltip-icon" />
									</OverlayTrigger>
								</Form.Label>
								<Form.Control
									as="select"
									value={this.state.ransomwareFileId}
									onChange={(e) =>
										this.setState({
											ransomwareFileId: parseInt(e.target.value, 10),
										})
									}
								>
									<option value="0" disabled>
										Select Ransomware File
									</option>
									{this.state.ransomwareFiles.map((file, index) => (
										<option key={`ransomware-${index}`} value={file.id}>
											{file.name} ({file.description})
										</option>
									))}
								</Form.Control>
							</Form.Group>
						</Form>

						{this.hasRansomwareFileSelected()
							? this.renderRansomwarePreviewCard()
							: null}
					</div>
				</div>

				{this.hasRansomwareFileSelected() ? (
					<div className="mt-2">
						<div className="footer-wrapper justify-content-end d-flex">
							<Button
								className="btn closeBtn mr-2"
								variant="secondary"
								onClick={() => this.props.handleTabChange("prev")}
							>
								<ArrowBackOutlinedIcon className="btn-icon" /> Previous
							</Button>
							<Button
								variant="success"
								disabled={this.state.loading}
								type="button"
								onClick={this.handleSave}
							>
								<Spinner loading={this.state.loading} />
								<ArrowForwardOutlinedIcon
									className={
										this.state.loading ? "btn-icon d-none" : "btn-icon"
									}
								/>
								Go To Next
							</Button>
						</div>
					</div>
				) : null}

				<PreviewImageModal
					show={this.state.showPreviewModal}
					onHide={this.handleClosePreviewModal}
					windowsImageSrc={this.state.previewWindowsImageSrc}
					macImageSrc={this.state.previewMacImageSrc}
					fileName={this.state.ransonware_file}
				/>
			</>
		);
	}
}
